import type { CanonicalBillingDocument } from "../../../../canonical/document.ts";
import { projectMollieInvoice } from "./projection/invoice.ts";
import { projectMollieSubscription } from "./projection/subscription.ts";
import { projectMolliePayment } from "./projection.ts";

export function projectMollieResourceToCanonical(
	resource: unknown,
	kind: "payment" | "subscription" | "invoice",
): CanonicalBillingDocument {
	if (kind === "subscription") {
		const projected = projectMollieSubscription(resource);
		return {
			kind: "subscription",
			provider: projected.provider,
			providerSubscriptionId: projected.providerSubscriptionId,
			providerCustomerId: projected.providerCustomerId,
			providerProfileId: projected.providerProfileId,
			status: projected.status,
			amount: projected.amount,
			currency: projected.currency,
			interval: projected.interval,
			description: projected.description,
			metadata: projected.metadata,
			nextPaymentDate: projected.nextPaymentDate,
			createdAt: projected.createdAt,
			canceledAt: projected.canceledAt,
			raw: projected.raw,
		};
	}
	if (kind === "invoice") {
		const projected = projectMollieInvoice(resource);
		return {
			kind: "invoice",
			provider: projected.provider,
			providerInvoiceId: projected.providerInvoiceId,
			providerProfileId: projected.providerProfileId,
			providerCustomerId: projected.providerCustomerId,
			status: projected.status,
			amount: projected.amount,
			amountPaid: projected.amountPaid,
			description: projected.description,
			metadata: projected.metadata,
			issuedAt: projected.issuedAt,
			paidAt: projected.paidAt,
			createdAt: projected.createdAt,
			raw: projected.raw,
		};
	}
	const projected = projectMolliePayment(resource);
	return {
		kind: "payment",
		provider: projected.provider,
		providerPaymentId: projected.providerPaymentId,
		providerCustomerId: projected.providerCustomerId,
		providerProfileId: projected.providerProfileId,
		providerSubscriptionId: projected.providerSubscriptionId,
		providerPaymentLinkId: projected.providerPaymentLinkId,
		status: projected.status,
		amount: projected.amount,
		amountRefunded: projected.amountRefunded,
		description: projected.description,
		metadata: projected.metadata,
		paidAt: projected.paidAt,
		createdAt: projected.createdAt,
		raw: projected.raw,
	};
}
